/**
 * <ln-carousel autoplay="5000">
 *   <div class="ln-carousel__track" data-track> <div class="ln-carousel__slide">…</div> … </div>
 *   <button data-prev> <button data-next>
 * </ln-carousel>
 *
 * Native scroll-snap does the sliding; this only wires the buttons, keeps their disabled state
 * in sync, and optionally autoplays (paused on hover/focus, off for prefers-reduced-motion).
 */
if (!customElements.get('ln-carousel')) {
  customElements.define(
    'ln-carousel',
    class LnCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');

        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        new ResizeObserver(() => this.update()).observe(this.track);
        this.update();

        const interval = Number(this.getAttribute('autoplay'));
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (interval > 0 && !reduceMotion) this.startAutoplay(interval);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      step() {
        const slides = this.track.children;
        if (slides.length < 2) return this.track.clientWidth;
        return slides[1].offsetLeft - slides[0].offsetLeft;
      }

      go(direction) {
        this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
      }

      atEnd() {
        return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }

      update() {
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.atEnd();
      }

      startAutoplay(interval) {
        let paused = false;
        const pause = () => (paused = true);
        const resume = () => (paused = false);
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.timer = setInterval(() => {
          if (paused || document.hidden) return;
          if (this.atEnd()) this.track.scrollTo({ left: 0, behavior: 'smooth' });
          else this.go(1);
        }, interval);
      }
    }
  );
}
